/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations, Outlines } from "@react-three/drei";
import {
  darkBlueMaterial,
  greenShirtMaterial,
  hairMaterial,
  skinMaterial,
} from "../../../../common/materials";

const model = "/models/desk/character.glb";

export default function Character({ ...props }) {
  const group = useRef();
  const { nodes, materials, animations } = useGLTF(model);
  const { actions } = useAnimations(animations, group);

  useEffect(() => {
    actions.writing.play();
  }, []);

  return (
    <group ref={group} {...props} dispose={null}>
      <group
        name="character_armature"
        position={[-2.25, 0, 1.61]}
        rotation={[Math.PI / 2, 0, 0]}
        scale={0.01}
      >
        <primitive object={nodes.mixamorigHips} />
        <group name="character">
          <skinnedMesh
            castShadow
            receiveShadow
            name="Circle032"
            geometry={nodes.Circle032.geometry}
            material={hairMaterial}
            skeleton={nodes.Circle032.skeleton}
          ></skinnedMesh>
          <skinnedMesh
            castShadow
            receiveShadow
            name="Circle032_2"
            geometry={nodes.Circle032_2.geometry}
            material={skinMaterial}
            skeleton={nodes.Circle032_2.skeleton}
          ></skinnedMesh>
          <skinnedMesh
            castShadow
            receiveShadow
            name="Circle032_4"
            geometry={nodes.Circle032_4.geometry}
            material={greenShirtMaterial}
            skeleton={nodes.Circle032_4.skeleton}
          ></skinnedMesh>
          <skinnedMesh
            castShadow
            receiveShadow
            name="Circle032_3"
            geometry={nodes.Circle032_3.geometry}
            material={darkBlueMaterial}
            skeleton={nodes.Circle032_3.skeleton}
          ></skinnedMesh>
          <skinnedMesh
            castShadow
            receiveShadow
            name="Circle032_1"
            geometry={nodes.Circle032_1.geometry}
            material={materials["shoes"]}
            skeleton={nodes.Circle032_1.skeleton}
          ></skinnedMesh>
        </group>
      </group>
    </group>
  );
}

useGLTF.preload(model);
